// extracted by mini-css-extract-plugin
export default {"breakpointSM":"0","breakpointMD":"768","breakpointLG":"1024","breakpointXL":"1440"};